// Vendor
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
// Components
import Spinner from '../../components/Spinner';
import AppLink from '../../components/AppLink';
// Styles
import './style.styl';

const Button = ({
  className,
  big,
  icon,
  loading,
  dir,
  wide,
  mobilewide,
  light,
  lightMuted,
  children,
  social,
  ...props
}) => {
  const classes = cn({
    Button: true,
    Button_big: big,
    Button_wide: wide,
    Button_mobilewide: mobilewide,
    Button_light: light,
    'Button_light-muted': lightMuted,
    Button_back: dir === 'back',
    Button_forward: dir === 'forward',
    'Button_with-icon': icon,
    Button_social: social,
    [`Button_social_${social}`]: social,
    [className]: className,
  });
  const TagName = props.href ? AppLink : 'button';

  return (
    <TagName className={classes} {...props}>
      {loading && <Spinner size={30} currentColor />}
      {!loading && icon && (
        <img className="Button__icon" src={`/static/images/Button/icon_${icon}.png`} />
      )}
      {!loading && social && (
        <img
          className="Button__icon Button__icon_social"
          src={`/static/images/icons/social_${social}.svg`}
        />
      )}
      {!loading && children && <span className={cn('Button__text')}>{children}</span>}
    </TagName>
  );
};

Button.defaultProps = {
  className: '',
  loading: false,
  onClick: () => {},
};

Button.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
};

export default Button;



// WEBPACK FOOTER //
// components/Button/index.js